"use client";

import { toast as sonnerToast } from "sonner";

const toast = ({
    description,
    variant,
}: {
    variant?: "success" | "destructive" | "info";
    description: string;
}) => {
    switch (variant) {
        case "success":
            return sonnerToast.success(description);
        case "destructive":
            return sonnerToast.error(description);
        default:
            return sonnerToast(description);
    }
};

const useToast = () => {
    return {
        toast,
    };
};

export { useToast, toast };
